import { ButtonProps, CircularProgress } from '@mui/material';

import { Button } from './base-button-styles';

type Props = ButtonProps & {
  isLoading?: boolean;
};

const BaseButton = ({
  children,
  isLoading = false,
  disabled = false,
  ...props
}: Props) => {
  return (
    <Button
      value='button'
      endIcon={isLoading ? <CircularProgress size={20} /> : props.endIcon}
      variant='contained'
      disableElevation={true}
      disabled={isLoading || disabled}
      {...props}
    >
      {children}
    </Button>
  );
};

export default BaseButton;
